import React from "react";
import {useNavigate } from "react-router";
import UTILS from '../../utils/commons';


const ExpenseItem = props => {
    const data = props.data;
   
    return ( <div className="grid md:grid-cols-1 gap-2 md:justify-start md:items-center flex-wrap" id="list_container">
        <div className="grid md:grid-cols-5 p-2 ">
            <span>{UTILS.formatDate(data?.createdAt)}</span>
            <span>{UTILS.paymentType(data?.type)}</span>
            <span>{UTILS.thousandSeparator(data?.amount)}</span>
            <span>{data?.paidTo}</span>
            <span>{data?.reason}</span>
            {/* <span className="text-center">{data?.manager?.name}</span> */}
        </div> </div>
    )
}
export default ExpenseItem;